import { ProfileAdvancedSearchExportDto } from './dto/profile-advanced-search-export.dto';
import { Injectable } from '@angular/core';
import { UtilService, ApiService, PagedResultGeneric } from '../../shared/index';
import { IProfileSearchService } from './iprofile-search.service';
import { ProfileSearchParams } from './profile-search-params.model';
import { ProfileAdvancedSearchParams } from './profile-advanced-search-params.model';
import { ProfileMin } from '../shared/profile-min.model';
import { ProfileSearchResult } from './profile-search-result.model';
import { PagedResult } from '../../shared/model/generic-paged-result.model';
import { ProfileAdvancedSearchResultDto } from './dto/profile-advanced-search-result.dto';
import { ProfileServiceApiService } from 'src/app/shared/api/profile-service-api.service';
import { PagedDataTableDto } from 'src/app/shared/dto/paged-datatable.dto';
import { SerialSearchExpression } from 'src/app/shared/search-expression/serial-search-expression.model';

@Injectable()
export class ProfileSearchService implements IProfileSearchService {
  public _utilService: UtilService;
  public _apiService: ApiService;

  public constructor(utilService: UtilService, apiService: ApiService, private _profileServiceApiService: ProfileServiceApiService) {
    this._utilService = utilService;
    this._apiService = apiService;
  }

  public search(params: ProfileSearchParams): Promise<ProfileSearchResult> {
    return this._profileServiceApiService.postPaged('/profile/v2/search', params);
  }

  public quickSearch(keyword: string): Promise<ProfileSearchResult> {
    return this._apiService.getPaged('/Profiles/QuickSearch', { keyword });
  }

  public advancedSearch(params: ProfileAdvancedSearchParams): Promise<PagedResultGeneric<ProfileAdvancedSearchResultDto>> {
    let url: string = '/profile/v2/advanced-search';
    return this._profileServiceApiService.postPaged(url, this.prepareSearchParams(params));
  }

  public profileSelectorAdvancedSearch(params: ProfileAdvancedSearchParams): Promise<PagedDataTableDto> {
    let url: string = '/profile/v2/advanced-search/profile-selector';
    return this._profileServiceApiService.postPaged(url, this.prepareSearchParams(params));
  }

  public getPossibleDuplicates = (name: string): Promise<PagedResult<Array<ProfileMin>>> => {
    let url: string = '/Profiles';
    let params = new ProfileSearchParams();
    params.OrderBy = 'ReportName:asc';
    params.PageNumber = 1;
    params.PageSize = 50;
    params.Keyword = name;
    params.RestrictToOrganization = false;
    params.RestrictToIndividual = false;
    params.RestrictToMember = false;
    params.RestrictToActive = true;
    params.RestrictToProspect = false;

    return this._apiService.getPaged(url, params).then((data: ProfileSearchResult) => {
      let results = new PagedResult<Array<ProfileMin>>();
      if (data.Result.length > 0) {
        results = data;
      }

      return Promise.resolve(results);
    });
  };

  public exportSearchToCsv(exportDto: ProfileAdvancedSearchExportDto, exportAll = false) {
    if (exportAll) {
      exportDto.ProfileAdvancedSearchDto.PageNumber = 0;
      exportDto.ProfileAdvancedSearchDto.PageSize = 0;
    }
    return this._apiService.post('/Profile/AdvancedSearch/CSV', exportDto);
  }

  public exportSystemColumnsToCsv(exportDto: ProfileAdvancedSearchParams, exportAll = false) {
    exportDto.OrderBy = '';
    return this._profileServiceApiService.post('/profile/v2/advanced-search/profile-selector/SystemColumnsExport', exportDto);
  }

  public profileSelectorexportSearchToCsv(exportDto: ProfileAdvancedSearchParams, exportAll = false) {
    return this._profileServiceApiService.post('/profile/v2/advanced-search/profile-selector/export', exportDto);
  }

  private prepareSearchParams(params: ProfileAdvancedSearchParams): ProfileAdvancedSearchParams {

    const preparedParams = { ...params };

    const ensureStringValues = (expressions: SerialSearchExpression[]) => {
      for (let expression of expressions.filter((x) => x.Value != null)) {
        expression.Value = expression.Value.toString();
      }
    };

    ensureStringValues(preparedParams.ContactInfoSearchExpressions);
    ensureStringValues(preparedParams.MemberActivitySearchExpressions);
    ensureStringValues(preparedParams.CategorySearchExpressions);
    ensureStringValues(preparedParams.EventsSearchExpressions);
    ensureStringValues(preparedParams.VoterVoicehExpressions);

    return preparedParams;
  }
}
